import { useNavigate } from "react-router";
import { CreateTppWebFormV2ParamsOperationEnum } from "@bn/api/apiv1";
import { MultibankingApiProvider } from "@api";
import { createAndRedirectToTppWebForm } from "@helpers/createAndRedirectToTppWebForm";
import { useBankImportReturnUrl } from "./useBankImportReturnUrl";

export const useRoutes = () => {
  const navigate = useNavigate();
  const { getReturnUrl } = useBankImportReturnUrl();

  const pushImportConnection = async (
    bankSlug: string,
    multibankingProvider: MultibankingApiProvider,
    // For callers that redirect in the same tick they decide where to return
    // to. `getReturnUrl` reads this hook's own state, which still holds the
    // value from its last render, so a `saveReturnUrl` from the same tick would
    // be read as null and then overwritten with it.
    returnUrl?: string | null
  ) => {
    return await createAndRedirectToTppWebForm({
      provider: multibankingProvider,
      bankSlug,
      returnUrl: returnUrl === undefined ? getReturnUrl() : returnUrl,
    });
  };

  const pushUpdateConnection = async (
    bankConnectionId: number,
    multibankingProvider: MultibankingApiProvider
  ) => {
    return await createAndRedirectToTppWebForm({
      provider: multibankingProvider,
      bankConnectionId,
      returnUrl: getReturnUrl(),
    });
  };

  const pushLegalNote = (
    bankSlug: string,
    multibankingProvider: MultibankingApiProvider
  ) => {
    if (multibankingProvider === "WEALTH_API") {
      createAndRedirectToTppWebForm({
        provider: multibankingProvider,
        bankSlug,
        returnUrl: getReturnUrl(),
      });
      return;
    }
    navigate(`/import-bank-connection/${bankSlug}/legal-note`);
  };

  const pushAddAccountsToConnection = async (
    bankConnectionId: number,
    multibankingProvider: MultibankingApiProvider
  ) => {
    return await createAndRedirectToTppWebForm({
      provider: multibankingProvider,
      bankConnectionId,
      operation: CreateTppWebFormV2ParamsOperationEnum.ADD_ACCOUNTS,
      returnUrl: getReturnUrl(),
    });
  };

  const pushAddInterfacesToConnection = async (
    bankConnectionId: number,
    multibankingProvider: MultibankingApiProvider
  ) => {
    return await createAndRedirectToTppWebForm({
      provider: multibankingProvider,
      bankConnectionId,
      operation: CreateTppWebFormV2ParamsOperationEnum.ADD_INTERFACES,
      returnUrl: getReturnUrl(),
    });
  };

  return {
    pushImportConnection,
    pushUpdateConnection,
    pushLegalNote,
    pushAddAccountsToConnection,
    pushAddInterfacesToConnection,
  };
};
